import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import { deleteBundle } from 'project/ducks/wrapup';
import ConfirmDialog from 'common/components/modal/confirmation_dialog';

const mapStateToProps = (_, { bundleId }) => {
  return {
    dialogVisible: !!bundleId,
    dialogHeader: "Are you sure you want to permanently delete this bundle?",
    dialogMessage: "This action can't be undone.",
  };
}

const mapDispatchToProps = (dispatch, { wrapup, bundleId, backendStepIdx, toggleDialog }) => {
  return bindActionCreators({
    submitAction: partial(deleteBundle, wrapup, bundleId, backendStepIdx, toggleDialog),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmDialog);



// WEBPACK FOOTER //
// ./project/containers/wrapup/delete_bundle_modal.js